import React, { useEffect, useState } from 'react'; 
import { Link } from 'react-router-dom';
import { postTransferCertificate } from '../Service/Api';
import Header from'../Component/Header'
import Footer from'../Component/Footer' 
const Tc = () => {
  useEffect(() => {
    // Set the page title
    document.title = 'Transfer Certificate - Presentation Convent School Delhi';  
  }, []);
  const [admission, setAdmission] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleAdmissionNoChange = (event) => {
    setAdmission(event.target.value);
    setError("");
  };

  const handleFullNameChange = (event) => {
    setName(event.target.value);
    setError("");
  };

  const getDownloadUrl = (responseData) => {
    if (!responseData) return "";
    if (typeof responseData === "string") {
      if (responseData.startsWith("http://") || responseData.startsWith("https://")) {
        return responseData;
      }

      return `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${responseData.replace(/^\/+/, "")}`;
    }

    if (responseData.url) {
      return responseData.url;
    }

    if (responseData.file) {
      return `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${responseData.file.replace(/^\/+/, "")}`;
    }

    return "";
  };

  const triggerDownload = async (fileUrl) => {
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error("Download request failed");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileUrl.split('/').pop() || 'transfer-certificate.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !admission) {
      setError("Please fill in all fields");
      return;
    }
    
    try {
      const response = await postTransferCertificate(name, admission);
      const downloadUrl = getDownloadUrl(response?.data);

      if (!downloadUrl) {
        setError("TC file was not returned by the server.");
        return;
      }

      await triggerDownload(downloadUrl);
    } catch (error) {
      console.error("Failed to post data", error);
      setError("Failed to process your request. Please try again later.");
    }
  };

  return (
     <>
       <Header/>
        <div className="innerslide"> 
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Quick Links  </li>
                <li>Transfer Certificate</li>
            </ul>
       </div>
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Transfer Certificate</h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-md-12"> 
                <div className="tcblock">
                <div className="tc">
                      <form onSubmit={handleSubmit} >
                     <div>
                        <div className="formfil">
                            <div className="form-group">
                              <label htmlFor="admission"><p> Admission No. </p></label>
                              <input id="admission" type="text" className="form-control" value={admission} onChange={handleAdmissionNoChange} />
                            </div>
                             <div className="form-group">
                              <label htmlFor="student-name"><p> Student Full Name </p></label>
                              <input id="student-name" type="text" className="form-control" value={name} onChange={handleFullNameChange} />
                            </div>
                        </div>
          
                        <div className="clr30"></div>
                     <input type="submit" className="viewdetailsbtn"  value="Submit" />
                      </div>
                      </form>
                 </div>
                  {error ? <p className="text-danger">{error}</p> : null}
                  <iframe title="TC sample" src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/pdf/TC-Sample.pdf#toolbar=0' width="100%" height="500"></iframe>
           </div>
                </div>
                 </div>
            </div>  
        </div> 
       <Footer/>
     </>
  )
}

export default Tc
